import { useReactiveVar } from '@apollo/client'

import { useGetSpacesQuery } from 'modulesCommon/graphql/queries/getSpaces.types'
import { spaceIdVar } from 'modulesCommon/store'


export const useSpaceZone = () => {
  const spaceId = useReactiveVar(spaceIdVar)
  
  const { data: spacesResponse, loading: spacesLoading, error: spacesError } = useGetSpacesQuery()
  const spaceZoneOptions =
    spacesResponse?.getSpaces
      .find((item) => item.id === spaceId)
      ?.labels.map((labelItem) => ({
        label: labelItem.name,
        value: labelItem.id
      })) ?? []

  return {
    spaceZoneOptions,
    spacesLoading,
    spacesError
  }
}
